var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowlefticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.75001C10.6753 3.74967 10.8451 3.8107 10.98 3.92251C11.1334 4.04967 11.2299 4.23264 11.2482 4.43103C11.2665 4.62943 11.2051 4.82695 11.0775 4.98001L7.71752 9.00001L10.9575 13.0275C11.0833 13.1825 11.1422 13.3812 11.1211 13.5796C11.1 13.7781 11.0006 13.96 10.845 14.085C10.6881 14.223 10.4808 14.2894 10.2729 14.268C10.0651 14.2467 9.87555 14.1396 9.75002 13.9725L6.12752 9.47251C5.90003 9.19576 5.90003 8.79676 6.12752 8.52001L9.87752 4.02001C10.0301 3.83593 10.2613 3.73564 10.5 3.75001Z",
    fill: "#212B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowlefticon);
export default __webpack_public_path__ + "static/media/arrowlefticon.d435a05fd3a10a554847408333dd0d9a.svg";
export { ForwardRef as ReactComponent };